import * as tldjs from 'tldjs';

export default function isValidLink(url?: string | null): boolean {
  if (url == null) {
    return false;
  }
  try {
    const urlObj = new URL(url);
    if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
      return false;
    }
    if (url.includes(' ')) {
      return false;
    }
    // Ensure hostname contains a dot (reject single words like "google") and has a valid TLD
    return urlObj.hostname.includes('.') && tldjs.tldExists(urlObj.hostname);
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch (e) {
    return false;
  }
}
